import { ActionIcon, Button, Group } from '@mantine/core';
import { IconFolderPlus, IconUpload } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  onCreateFolder: () => void;
  onUpload: () => void;
};

export default function FiledDocumentsHeaderActions({ onCreateFolder, onUpload }: Props) {
  return (
    <Group gap="xxs" wrap="nowrap">
      <ActionIcon
        variant="transparent"
        bg="brand.0"
        c="brand.7"
        size={36}
        style={{
          // Plain borderRadius because the theme's actionIconRoot class overrides the radius prop
          borderRadius: 12,
        }}
        onClick={onCreateFolder}
        aria-label="Create folder"
      >
        <IconFolderPlus size={20} stroke={1.5} />
      </ActionIcon>
      <Button
        variant="primary"
        size="sm"
        h={36}
        fw={FONT_WEIGHTS.semibold}
        rightSection={<IconUpload size={16} />}
        onClick={onUpload}
      >
        Upload
      </Button>
    </Group>
  );
}
